import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import Headroom from "react-headroom"
import Divider from "components/UI/Divider"
import t, { mixin } from "theme"
import { useMediaQuery } from "react-responsive"
import TopMenu from "components/Common/Header/TopMenu"
import { DesktopCompanyTabs, CompanyDropdown } from "components/Common/Header/CompanySelector"
import { DesktopFeatureSelector, MobileFeatureSelector } from "components/Common/Header/FeatureSelector"

//the issue seems to be: SSR renders everything with no desktop view, so when load for the first time, stuff flickers.
//and css inside also seems to get messed up.
//but this doesn't explain: why lack of shadow on load?

const Header = ({ commonData, selectedCompany, selectedFeature }) => {
    const menuProps = { commonData, selectedCompany, selectedFeature }

    const isPhone = useMediaQuery({
        query: `(max-width: ${t.breakpoint.small})`,
    })

    return (
        <div>
            <Headroom>
                <TopWrapper css={selectedCompany ? null : menuShadow}>
                    <InnerContainer>
                        <TopMenu {...menuProps} />
                    </InnerContainer>
                </TopWrapper>

                {selectedCompany ? (
                    <BottomWrapper>
                        <InnerContainer>
                            <div
                                css={css`
                                    display: flex;
                                    height: 100%;
                                    align-items: center;
                                    width: 100%;
                                    ${mixin.phonestyle} {
                                        justify-content: space-between;
                                    }
                                `}>
                                <CompanyDropdown {...menuProps} />
                                <Divider direction="V" space={t.space[5]} color={t.color.subtlegrey} size="70%" />
                                {isPhone ? (
                                    <MobileFeatureSelector {...menuProps} />
                                ) : (
                                    <DesktopFeatureSelector {...menuProps} />
                                )}
                            </div>
                        </InnerContainer>
                    </BottomWrapper>
                ) : isPhone ? null : (
                    <BottomWrapper>
                        <InnerContainer>
                            <DesktopCompanyTabs {...menuProps} />
                        </InnerContainer>
                    </BottomWrapper>
                )}
            </Headroom>
        </div>
    )
}

export default Header

const InnerContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: ${t.sitewide.containerWidth};
    width: 100%;
    height: 100%;
    margin: 0 auto;
`

const TopWrapper = styled.div`
    border-bottom: 1px solid ${t.color.nearwhite};
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5px);
    height: 65px;
    position: relative;
    z-index: 1000;
    display: flex;
    align-items: center;
    ${mixin.tabletandphonestyle} {
        padding: 0 10vw;
        height: 8vw;
    }
    ${mixin.phonestyle} {
        padding: 0 5vw;
        height: 13vw;
    }
`

const BottomWrapper = styled.div`
    box-shadow: 0 0rem 0.3rem 0 ${t.color.border};
    overflow-y: visible;
    background-color: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(5px);
    height: 60px;
    ${mixin.tabletandphonestyle} {
        padding: 0 10vw;
        height: 7vw;
    }
    ${mixin.phonestyle} {
        padding: 0 5vw;
        height: 12vw;
    }
`

const menuShadow = css`
    ${mixin.phonestyle} {
        box-shadow: 0 0rem 0.3rem 0 ${t.color.border};
        overflow-y: visible;
        background-color: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(5px);
    }
`
